import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["data-tour"]
const _hoisted_2 = ["aria-selected", "onClick"]


export default {
  __name: 'CustomerTabBar',
  props: {
  tabs: { type: Array, required: true },
  activeTab: { type: String, required: true }
},
  emits: ['select'],
  setup(__props, { emit: __emit }) {



const emit = __emit

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("nav", {
    "data-tour": __props.tabs.length > 1 ? 'customer-tabs' : undefined,
    class: "customer-tabbar",
    role: "tablist",
    "aria-label": "Customer sections",
    style: _normalizeStyle({ gridTemplateColumns: `repeat(${__props.tabs.length}, minmax(0, 1fr))` })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
      return (_openBlock(), _createElementBlock("button", {
        key: tab.key,
        type: "button",
        role: "tab",
        "data-test": "bottom-tab",
        class: "customer-tabbar__tab",
        "aria-selected": String(tab.key === __props.activeTab),
        onClick: $event => (emit('select', tab.key))
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon), {
          class: "h-[21px] w-[21px]",
          "aria-hidden": "true"
        })),
        _createElementVNode("span", null, _toDisplayString(tab.label), 1)
      ], 8, _hoisted_2))
    }), 128))
  ], 12, _hoisted_1))
}
}

}